import { create } from 'zustand';
import { deleteCookie, getCookie, setCookie } from '../shared/Cookie';


const cookieKey = "PHPSESSID"

type LoginStateStore = {
  loginToken: string,
  addLoginToken: (token: string) => void
  removeLoginToken: () => void
}

export const useLoginStateStore = create<LoginStateStore>((set, get) => ({
  loginToken: getCookie("PHPSESSID") || "",
  addLoginToken: (loginToken: string) => {
    setCookie(cookieKey, loginToken);
    set({ loginToken });
  },
  removeLoginToken: () => {
    deleteCookie(cookieKey)
    set({ loginToken: "" })
  }
}))


export const logOut = () => useLoginStateStore.getState().removeLoginToken();